import React from 'react';
import { Dialog, DialogContent, Card, CardContent } from '@mui/material';
import prevIcon from "../../assets/icons/prevIcon.svg"
import nextIcon from "../../assets/icons/nextIcon.svg"

const ClaimNoteHistory = (props) => {
    let path = window.location.pathname;
    let patient = props?.viewData?.[0]
    let notesData;
    switch (path) {
        case '/rule-processor':
            notesData = props?.viewData?.AR_Transaaction?.filter(item => item.TransectionType == "Note")
            break;
        case '/patient-details':
            notesData = patient?.notes
            break;
        case '/denial-management':
        case '/noresponse-management':
            notesData = props?.viewData?.Notes
            break;
        default:
            break;
    }
    return (
        <>
            <Dialog className='claimModal'
                fullWidth
                open={props.openNote}
                onClose={props.closeNotePopup} style={{ width: '100%' }}>
                <div className='claimDialog'>
                    <div className='d-flex align-items-center claimNoteDiv justify-content-between px-3'>
                        <span className='claimNote'>Claim Note History</span>
                        {path != '/patient-details' && <div>{`${(props.firstPage) + 1} of ${props.totalPage}`}
                            <button onClick={props.clickPrevious} className='navigateBtn' disabled={props.firstPage == 0 ? true : false}>
                                <img src={prevIcon} />
                            </button>
                            <button onClick={props.clickNext} className='navigateBtn' disabled={(props.firstPage) + 1 == props.totalPage ? true : false}>
                                <img src={nextIcon} />
                            </button>
                        </div>}
                    </div>
                    <DialogContent>
                        <Card className='noteCard '>
                            <div className='w-100'>
                                <div className='modalHeading'>
                                    <span >Encounter Details</span>
                                </div>
                                <CardContent className='border-bottom'>
                                    <div className='row'>
                                        <div className='col-6'>
                                            <label><strong>Patient Name: </strong><span>{props?.viewData?.PatientName || patient?.PatientName}</span></label><br />
                                            <label><strong>Provider: </strong><span>{props?.viewData?.SchedulingProviderName || patient?.SchedulingProviderName}</span></label><br />
                                            <label><strong>Location: </strong><span>{props?.viewData?.ServiceLocationName || patient?.ServiceLocationName}</span></label>
                                        </div>
                                        <div className='col-3'>
                                            <label><strong>Encounter: </strong><span>{props?.viewData?.EncounterID || patient?.EncounterID}</span></label><br />
                                            {(path == '/denial-management' || path == '/noresponse-management') && <><label><strong>Claim ID: </strong><span>{props?.viewData?.CLAIMID}</span></label><br /></>}
                                            <label><strong>Procedure: </strong><span>{props?.viewData?.Code || props?.viewData?.ProcedureCode || patient?.ProcedureCode}</span></label>
                                        </div>
                                        <div className='col-3'>
                                            <label><strong>DOS: </strong><span>{props?.viewData?.ServiceStartDate || patient?.ServiceStartDate}</span></label><br />
                                            {(path == '/denial-management' || path == '/noresponse-management') && <><label><strong>Last Billed Date: </strong><span>{new Date(props?.viewData?.created_at).toLocaleDateString('en-US')}</span></label><br /></>}
                                            {(path == '/denial-management' || path == '/noresponse-management') && <label><strong>No Resp Date: </strong>
                                                <span>
                                                    {path == '/denial-management' ? new Date(props?.viewData?.Denial_Date).toLocaleDateString('en-US') : new Date(props?.viewData?.NoRespDate).toLocaleDateString('en-US')}
                                                </span>
                                            </label>}
                                        </div>
                                    </div>
                                </CardContent>
                            </div>
                            <div style={{ overflowY: 'scroll', width: '100%' }}>{notesData?.length > 0 ? notesData?.map((note, idx) => (
                                <div className='contentBox'>
                                    <div className='innerContent'>
                                        <span>{note.NOTES || note.ValueUpdated}</span><br />
                                        <span style={{ fontSize: 13 }}>Posting Date: {new Date(note.CREATEDDATE || note.CreatedAt).toLocaleString("en-US", {
                                            year: "2-digit",
                                            month: "numeric",
                                            day: "numeric",
                                            hour: "2-digit",
                                            minute: "2-digit",
                                            hour12: true,
                                        })}</span><br />
                                        <span style={{ fontSize: 13 }}>User: {note.USERNAME || note.CommitedBy}</span><br />
                                        <span style={{ fontSize: 13 }}>Created In: {note.CREATEDIN || note.CreatedIn}</span>
                                    </div>
                                </div>
                            )) :
                                <div className='innerContent'>
                                    <span>There are no notes for this claim...</span>
                                </div>
                            }</div>
                        </Card>
                        <div className='mt-3'>
                            <button className='close_button' onClick={props.closeNotePopup}>CLOSE</button>
                        </div>
                    </DialogContent>
                </div>
            </Dialog>
        </>
    )
}

export default ClaimNoteHistory;